{
	"title": "Transaktion nicht gefunden",
	"description": "Bitte gehen Sie zur Übersicht und geben Sie eine gültige Transaktions-ID ein. Eine Transaktions-ID finden Sie auf einer Erklärung oder auf einer Rechnung.",
	"secondaryButtonTitle": "Startseite anzeigen"
}
